import React, { useEffect, useState } from "react";
import useProductStore from "../../Stores/useProductStore";
import useCategoryStore from "../../Stores/useCategoryStore";
import InfiniteScrollList from "../../Components/Shared/InfiniteScroll/InfiniteScrollList";
import Polaroid from "../../Components/Gifts/Polaroid";
import NewPolaroid from "../../Components/Products/NewPolaroid";
import styles from "./ProductsPage.module.css";
import CategorySelector from "../../Components/Products/CategorySelection/CategorySelector";
import {useNavigate} from 'react-router-dom';
import { useCategorySelection } from "../../Hooks/useCategorySelection";
function ProductsPage() {
  const { getProducts, products, getItemsPaged,getProductsByCategoryOrFriendlyName,categoriesList } = useProductStore();
  // const [selectedCategory, setSelectedCategory] = useState(null);
  const navigate = useNavigate();
const { selectedCategory, handleCategorySelect } = useCategorySelection();
  
  const categoryData = categoriesList.find(
  cat => cat.CategoryName === selectedCategory?.FriendlyName
);

const productsToShow = selectedCategory
  ? categoryData?.Items || []
  : [];

  return (
    <div className={styles.ProductsPage}>      
      <CategorySelector categorySelected={handleCategorySelect} selectedCategory={selectedCategory} />
      <div className={styles.selectedCategory}>
        {selectedCategory && selectedCategory?.Value ? selectedCategory.Value : "All Products"}
      </div>
      <div className={styles.Wrapper}>        
        {selectedCategory == null ?( 
        <InfiniteScrollList
          fetchItems={ getItemsPaged }
          pageSize={20}
          RenderItem={NewPolaroid}
          itemProps={{}}
        />): (
            productsToShow.map((product, index) => (
              <NewPolaroid
                key={index}
                Name={product.Name}
                Price={product.Price}
                FriendlyName={product.FriendlyName}
                Images={product.Images}
              />
            ))
        )}
      </div>
    </div>
  );
}

export default ProductsPage;
